export default "__VITE_ASSET__BvAA250k__"